import { resolveMediaUrl } from "./mediaUrl";

/** Filtri Assisi: niente macro-categoria UNESCO / Palazzaccia. */

export function isExcludedAssisiMonument(monument) {
  if (!monument) return true;
  const slug = String(monument.slug || monument.id || "").toLowerCase();
  const nameRaw = monument.name;
  const name = String(typeof nameRaw === "string" ? nameRaw : nameRaw?.it || "").toLowerCase();
  const wd = String(monument.wikidata_id || "").toLowerCase();
  const source = String(monument.source || "").toLowerCase();
  const kind = String(monument.kind || "").toLowerCase();
  if (slug.includes("palazzaccia")) return true;
  if (wd === "q16913154") return true;
  if (name.includes("franciscan sites") || name.includes("other franciscan")) return true;
  if (source === "wikidata-unesco" && (name.includes("assisi") || name.includes("francesco"))) return true;
  if (kind.includes("unesco") && name.includes("franciscan")) return true;
  return false;
}

export function filterAssisiMonuments(list, villageSlug) {
  const rows = Array.isArray(list) ? list : [];
  if (String(villageSlug || "").toLowerCase() !== "assisi") return rows;
  return rows.filter((m) => !isExcludedAssisiMonument(m));
}

/** Sottocartelle /images/assisi/* riservate alle schede monumento (non galleria comune). */
const ASSISI_MONUMENT_MEDIA_MARKERS = [
  "/assisi/basilica-san-francesco/",
  "/assisi/cripta-san-francesco/",
  "/assisi/cattedrale-san-rufino/",
  "/assisi/santuario-spogliazione/",
  "/assisi/presepe-castelli/",
  "/assisi/presepe-monumentale",
  "/assisi/carlo-acutis",
  "/assisi/san-rufino",
  "/assisi/san-francesco-sacro-convento",
  "/assisi/san-francesco-piazza",
];

/** Percorsi territoriali ammessi nella galleria hub comune. */
const ASSISI_TERRITORY_MEDIA_MARKERS = [
  "/assisi/vicolo-angelini",
];

/**
 * True se l'URL appartiene a un monumento Assisi (cartella statica), non alla galleria comune.
 * Upload admin/API restano sempre galleria comune.
 */
export function isAssisiMonumentMediaPath(url) {
  const u = String(resolveMediaUrl(url) || url || "").toLowerCase();
  if (!u || u.includes("palazzaccia")) return true;
  if (u.includes("/api/uploads/")) return false;
  if (ASSISI_TERRITORY_MEDIA_MARKERS.some((m) => u.includes(m))) return false;
  if (!u.includes("/assisi/") && !u.includes("assisi")) return false;
  return ASSISI_MONUMENT_MEDIA_MARKERS.some((m) => u.includes(m));
}

/**
 * Galleria hub Storia Assisi: solo foto comune curate (no merge monumenti, no preset monumenti).
 * Il merge da monumenti (fino a 3 foto ciascuno) e ASSISI_GALLERY gonfiavano il mosaico con
 * interni, close-up e duplicati — fuori contesto per la galleria territoriale.
 */
export function mergeAssisiTerritoryGallery(comuneGallery, _monuments) {
  const seen = new Set();
  const out = [];
  for (const src of comuneGallery || []) {
    const url = resolveMediaUrl(src);
    if (!url || seen.has(url) || isAssisiMonumentMediaPath(url)) continue;
    seen.add(url);
    out.push(url);
  }
  return out;
}
